import React from "react";
import { Box, Button, InputAdornment, LinearProgress, Paper, TextField, Typography } from "@material-ui/core";
import { AssignmentOutlined, CheckCircleOutline, FindInPageOutlined, Search } from "@material-ui/icons";
import AnswerField from "./AnswerField";
import { answerState, hasAnswer } from "./answerPresentation";
import useStyles from "./detailStyles";

const filters = [
  ["all", "همه پاسخ‌ها"], ["correct", "پاسخ‌های صحیح"], ["incorrect", "پاسخ‌های غلط"],
  ["unanswered", "بدون پاسخ"], ["excluded", "حذف از آزمون"],
];
const matchesFilter = (item, value) => {
  if (value === "all") return true;
  if (value === "unanswered") return !hasAnswer(item) && !item.excludedFromScoring;
  return answerState(item) === value;
};

export default function AnswerReview({ fields, score, isExam = true, search, filter, onSearchChange, onFilterChange,
  summaryTitle = "خلاصه نتیجه آزمون", summaryDescription, answerTitle = "پاسخ‌های ثبت‌شده", emptyText = "پاسخی در این ورودی ثبت نشده است" }) {
  const classes = useStyles();
  const answers = fields.map((item, index) => ({ item, number: index + 1 }));
  const query = search.trim().toLocaleLowerCase();
  const visible = answers.filter(({ item }) => matchesFilter(item, filter) &&
    (!query || [item.title, item.userInput, item.rightAnswer, ...(item.acceptedAnswers || [])]
      .some(value => String(value ?? "").toLocaleLowerCase().includes(query))));
  const percent = score?.total ? Math.round(score.correct / score.total * 100) : 0;
  return <>
    {isExam && <Paper component="section" aria-label={summaryTitle} elevation={0} className={classes.panel}>
      <Box className={classes.score}>
        <Box><Typography component="h3" className={classes.heading}><CheckCircleOutline />{summaryTitle}</Typography>
          {score ? <Box className={classes.scoreValue}><strong>{score.correct.toLocaleString("fa-IR")}</strong><span>از {score.total.toLocaleString("fa-IR")} پاسخ صحیح</span></Box> :
            <Typography className={classes.scoreCaption}>خلاصه نتیجه موجود نیست.</Typography>}
          {summaryDescription && <Typography className={classes.scoreCaption}>{summaryDescription}</Typography>}
        </Box>
        {score && score.total > 0 && <Box className={classes.scoreProgress}>
          <Typography className={classes.scoreCaption}>درصد پاسخ‌های صحیح: {percent.toLocaleString("fa-IR")}٪</Typography>
          <LinearProgress variant="determinate" value={percent} aria-label="درصد پاسخ‌های صحیح" />
        </Box>}
      </Box>
    </Paper>}
    <Paper elevation={0} className={classes.panel}>
      <Box className={classes.panelHeading}><Typography component="h3" className={classes.heading}><AssignmentOutlined />{answerTitle}</Typography>
        <Typography className={classes.count}>{visible.length.toLocaleString("fa-IR")} از {answers.length.toLocaleString("fa-IR")} پاسخ</Typography>
      </Box>
      {answers.length > 0 && <Box className={classes.tools}>
        <TextField id="response-answer-search" label="جستجو در پاسخ‌ها" placeholder="متن سوال یا پاسخ" variant="outlined" size="small" value={search}
          onChange={event => onSearchChange(event.target.value)} className={classes.search}
          InputProps={{ startAdornment: <InputAdornment position="start"><Search fontSize="small" /></InputAdornment> }} />
        {isExam && <Box className={classes.filters}>{filters.map(([value, label]) => <Button key={value} size="small" aria-label={`نمایش ${label}`} aria-pressed={filter === value}
          className={`${classes.filter} ${filter === value ? classes.filterActive : ""}`} onClick={() => onFilterChange(value)}>
          {label} ({answers.filter(({ item }) => matchesFilter(item, value)).length.toLocaleString("fa-IR")})
        </Button>)}</Box>}
      </Box>}
      {visible.length > 0 ? <Box className={classes.answerList}>
        {visible.map(({ item, number }) => <AnswerField key={item._id || item.formFieldId || number} item={item} presentation="card" number={number} />)}
      </Box> : <Box className={classes.empty}><FindInPageOutlined /><Typography>{answers.length ? "پاسخی با این فیلتر پیدا نشد" : emptyText}</Typography>
        {(search || filter !== "all") && <Button color="primary" onClick={() => { onSearchChange(""); onFilterChange("all"); }}>نمایش همه پاسخ‌ها</Button>}
      </Box>}
    </Paper>
  </>;
}
